import type { SeatObservation } from "../types.js";
import { type AppNode, gameIntent, text } from "./view-nodes.js";

export function waveTimingControls(o: SeatObservation, id: string): AppNode[] {
  const routing = o.self.logistics.reinforcement;
  const timer = routing?.timers?.[id];
  const timed = routing?.modes[id] === "continuous";
  const due = timer?.nextAtMs ?? o.self.logistics.nextAutoReinforceAtMs;
  return [
    {
      kind: "range-input",
      id: `wave-time-${id}`,
      label: "Gather time (game seconds)",
      value: timer?.seconds ?? 5,
      min: 5,
      max: 120,
      step: 5,
      tooltip: "Timed waves wait this long between launches. Changing it restarts the countdown.",
      intent: (seconds) =>
        gameIntent(`wave-time-${id}`, {
          kind: "adjust-army",
          borderId: id,
          field: "seconds",
          value: seconds,
        }),
    },
    text(
      `wave-countdown-${id}`,
      timed
        ? `Next wave in ${Math.max(0, Math.ceil((due - o.gameTimeMs) / 1000))} game seconds`
        : "Assign an army share to start waves",
    ),
  ];
}
